import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { TrustBadges } from './ui/TrustBadges';
import { StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-white pt-6 pb-12 px-4" data-id="element-94">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-95">
        {/* Image Column */}
        <div className="relative w-full aspect-square md:aspect-[4/5] bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl overflow-hidden shadow-inner flex items-center justify-center border border-blue-100" data-id="element-96">
          <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide animate-pulse" data-id="element-97">
            🔥 OFERTA ESPECIAL
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/7r4KUhaBfMaruKfRoEtXNT/ChatGPT_Image_Mar_14,_2026,_07_52_46_AM.png" alt="Rodillera Térmica USB con calor terapéutico, cable USB incluido, bolsa de malla integrada y correas ajustables" className="w-full h-full object-cover" data-id="element-98" />
        </div>

        {/* Content Column */}
        <div className="flex flex-col justify-center" data-id="element-99">
          <div className="flex items-center gap-1 mb-3" data-id="element-100">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-101" />)}
            <span className="text-sm text-slate-600 ml-2 font-medium" data-id="element-102">
              +10,000 clientes felices
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 leading-tight mb-4" data-id="element-103">
            Alivia el Dolor de Rodilla al Instante
          </h1>

          <p className="text-lg md:text-xl text-slate-600 mb-6" data-id="element-104">
            Rodillera Térmica USB con Calor Terapéutico – Ajustable, Cómoda y
            Diseñada para tu Bienestar.
          </p>

          <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 mb-8" data-id="element-105">
            <div className="flex flex-col mb-4" data-id="element-106">
              <span className="text-slate-500 line-through text-lg" data-id="element-107">
                Precio Normal: $1,400 MXN
              </span>
              <div className="flex items-baseline gap-3" data-id="element-108">
                <span className="text-4xl md:text-5xl font-black text-blue-700" data-id="element-109">
                  $699 MXN
                </span>
                <span className="bg-green-100 text-green-800 text-sm font-bold px-2 py-1 rounded" data-id="element-110">
                  Ahorras 50%
                </span>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-lg mb-6" data-id="element-111">
              <p className="text-yellow-800 font-medium text-center text-sm" data-id="element-112">
                <span className="font-bold" data-id="element-113">🔥 PROMOCIÓN:</span> Llévate 2
                unidades por solo{' '}
                <span className="font-bold text-lg" data-id="element-114">$999 MXN</span>
              </p>
            </div>

            <CTAButton data-id="element-115" />
            <TrustBadges className="mt-6" data-id="element-116" />
          </div>
        </div>
      </div>
    </section>;
}